module.exports = __webpack_public_path__ + "static/media/数字孪生行业应用-智慧基建-01.7ec80a81.jpg";